import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cca1f56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forward-meeting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "d-flex align-items-center justify-content-between px-3 pt-3 pb-2 fw-bold" }, " Forward this event ", -1 /* HOISTED */))
const _hoisted_3 = { class: "px-3 pt-2 mt-1" }
const _hoisted_4 = { class: "d-flex justify-content-end pb-3 mt-3 me-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagsInput = _resolveComponent("TagsInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_TagsInput, {
      class: "w-100 px-3",
      getData: _ctx.getUsersList,
      tags: _ctx.selectedUsers,
      onUpdateTags: _ctx.updateTags,
      placeholder: "Enter name",
      "is-focus": true,
      "is-for-messaging": true,
      "show-pill": false,
      classes: "w-100",
      focusOnInput: "true"
    }, null, 8 /* PROPS */, ["getData", "tags", "onUpdateTags"]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        class: "form-control",
        rows: "4",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.optionalMessage) = $event)),
        placeholder: "Type your message here (Optional)"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.optionalMessage]
      ])
    ]),
    _createCommentVNode(" Commenting for future use case "),
    _createCommentVNode(" <div class=\"chat-history-box m-3\">\r\n            <div class=\"form-group form-check custom-checkbox mb-0\">\r\n                <input type=\"checkbox\" class=\"form-check-input\" v-model=\"shareChatHistory\" id=\"meeting-chat-history\" />\r\n                <label class=\"form-check-label\" for=\"meeting-chat-history\"> Share entire chat history</label>\r\n            </div>\r\n        </div> "),
    _createElementVNode("footer", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-2 w-20 bg-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancel()))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary border border-primary w-20",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
      }, "Forward")
    ])
  ]))
}